// GA4 conversion tracking helpers.
// Sends events through gtag when present, otherwise falls back to the dataLayer
// so a GTM container can forward them to GA4.

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
    }
  } catch {
    // never let analytics break the page
  }
}

export function trackLead(formName, params = {}) {
  if (typeof window === "undefined") return;
  trackEvent("generate_lead", {
    form_name: formName,
    page_path: window.location.pathname,
    ...params,
  });
}

// Site-wide listeners: mailto:/tel: clicks and Calendly booking events.
export function initConversionTracking() {
  if (typeof window === "undefined" || window.__ga4TrackingInit) return;
  window.__ga4TrackingInit = true;

  document.addEventListener(
    "click",
    (e) => {
      const target = e.target;
      const link = target && target.closest ? target.closest("a[href]") : null;
      if (!link) return;
      const href = link.getAttribute("href") || "";
      const lower = href.toLowerCase();
      if (lower.startsWith("mailto:") || lower.startsWith("tel:")) {
        trackEvent("contact_click", {
          contact_type: lower.startsWith("mailto:") ? "email" : "phone",
          link_url: href,
          page_path: window.location.pathname,
        });
      }
    },
    true,
  );

  window.addEventListener("message", (e) => {
    if (!/^https:\/\/([a-z0-9-]+\.)*calendly\.com$/i.test(String(e.origin))) return;
    const data = e.data;
    if (data && data.event === "calendly.event_scheduled") {
      trackEvent("calendly_booking", { page_path: window.location.pathname });
    }
  });
}
